import { api } from './api';

export interface NewsletterSubscribePayload {
  email: string;
  name?: string;
  company?: string;
  source?: string;
  send_now?: boolean;
}

export const newsletterService = {
  async subscribe(payload: NewsletterSubscribePayload) {
    return api.post('/api/v1/newsletter/subscribe', payload);
  },
  async preview() {
    return api.get('/api/v1/newsletter/preview');
  },
};
